import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { Col, Container, Row } from "../../../../../components/Grid/Grid";
import { SVG_ICONS, Svg } from "../../../../../components/__common/Svg/Svg";
import { Typography } from "../../../../../components/__common/Typography/Typography";
import { TTSButton } from "../../../../../components/__common/_controls";
import { ROUTES } from "../../../../../configs/routes";
import {
  EVENT_CATEGORY_HOME_PAGE,
  EVENT_HOME_ACTION_GPS,
  EVENT_HOME_ACTION_SECURITY_PRIVACY,
} from "../../../../../constants/analytics";
import { ApplicationState } from "../../../../../store";
import { LayoutState } from "../../../../../store/reducers/layout-reducer";
import { UserState } from "../../../../../store/reducers/user-reducer";
import GoogleAnalytics from "../../../../../utils/GoogleAnalytics";
import { UtilsHome } from "../../../../../utils/UtilsHome";
import "./PersonalDataManagement.scss";
import ClickableElement from "../../../../../components/__common/_controls/Button/ClickableElement";

const PersonalDataManagement: React.FC = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const userState = useSelector<ApplicationState, UserState>(
    (state) => state.user
  );

  const layoutState = useSelector<ApplicationState, LayoutState>(
    (state) => state.layout
  );

  const [sustainabilityLink, setSustainabilityLink] = useState<string>("");
  useEffect(() => {
    let link: string = UtilsHome.getSustainabilityLink(
      layoutState.countryCode,
      layoutState.languageCode
    );

    if (!userState.isGeoIPLoading) {
      link = UtilsHome.getSustainabilityLink(
        userState.userCountryCode,
        layoutState.languageCode
      );
    }

    setSustainabilityLink(link);
  }, [
    userState.userCountryCode,
    layoutState.languageCode,
    userState.isGeoIPLoading,
    layoutState.countryCode,
  ]);

  const handleGPSRedirection = () => {
    history.push(ROUTES.ABOUT_GRPS);
    GoogleAnalytics.triggerEvent(
      EVENT_CATEGORY_HOME_PAGE,
      EVENT_HOME_ACTION_GPS
    );
  };

  const handleSecurityPrivacyRedirection = () => {
    const newWindow = window.open(
      sustainabilityLink,
      "_blank",
      "noopener,noreferrer"
    );
    if (newWindow) {
      newWindow.focus();
    }
    GoogleAnalytics.triggerEvent(
      EVENT_CATEGORY_HOME_PAGE,
      EVENT_HOME_ACTION_SECURITY_PRIVACY
    );
  };
  return (
    <div className="home-bottom-banner">
      <Container>
        <Typography
          variant="h3"
          component="h3"
          className="home-bottom-banner__title"
        >
          {t("PRIVACY_HOME_BODY_DATA_MANAGEMENT_TITLE")}
        </Typography>
        <Container>
          <Row className="home-bottom-banner__row">
            <>
              <Col xl={6} sm={12}>
                <ClickableElement
                  onClick={handleGPSRedirection}
                  className="home-bottom-banner__col"
                >
                  <div>
                    <Svg
                      className="home-bottom-banner__col__icon"
                      icon={SVG_ICONS.RIGHTS_RESPONSE}
                      width={93}
                      height={93}
                      title={t("PRIVACY_HOME_BODY_DATA_MANAGEMENT_GRRS")}
                    />

                    <Typography
                      variant="title2"
                      className="home-bottom-banner__col__title"
                    >
                      {t("PRIVACY_HOME_BODY_DATA_MANAGEMENT_GRRS")}
                      <TTSButton
                        onClick={(e) => {
                          // to prevent redirection during onClick on the TTS button
                          e.preventDefault();
                          e.stopPropagation();
                        }}
                        value={
                          t("PRIVACY_HOME_BODY_DATA_MANAGEMENT_GRRS") +
                          ". " +
                          t("PRIVACY_HOME_BODY_DATA_MANAGEMENT_GRRS_TEXT")
                        }
                      />
                    </Typography>

                    <Typography
                      variant="body1"
                      className="home-bottom-banner__col__caption subText"
                    >
                      {t("PRIVACY_HOME_BODY_DATA_MANAGEMENT_GRRS_TEXT")}
                    </Typography>
                  </div>
                </ClickableElement>
              </Col>
              <Col xl={6} sm={12}>
                <ClickableElement
                  onClick={handleSecurityPrivacyRedirection}
                  className="home-bottom-banner__col"
                >
                  <div>
                    <Svg
                      className="home-bottom-banner__col__icon"
                      icon={SVG_ICONS.ABOUT_PRIVACY}
                      width={93}
                      height={93}
                      title={t(
                        "PRIVACY_HOME_BODY_DATA_MANAGEMENT_ABOUT_PRIVACY"
                      )}
                    />

                    <Typography
                      variant="title2"
                      className="home-bottom-banner__col__title"
                    >
                      {t("PRIVACY_HOME_BODY_DATA_MANAGEMENT_ABOUT_PRIVACY")}
                      <TTSButton
                        onClick={(e) => {
                          e.preventDefault();
                          e.stopPropagation();
                        }}
                        value={
                          t("PRIVACY_HOME_BODY_DATA_MANAGEMENT_ABOUT_PRIVACY") +
                          ". " +
                          t(
                            "PRIVACY_HOME_BODY_DATA_MANAGEMENT_ABOUT_PRIVACY_TEXT"
                          )
                        }
                      />
                    </Typography>

                    <Typography
                      variant="body1"
                      className="home-bottom-banner__col__caption subText"
                    >
                      {t(
                        "PRIVACY_HOME_BODY_DATA_MANAGEMENT_ABOUT_PRIVACY_TEXT"
                      )}
                    </Typography>
                  </div>
                </ClickableElement>
              </Col>
            </>
          </Row>
        </Container>
      </Container>
    </div>
  );
};

export default PersonalDataManagement;
